import {
  Dispatch,
  memo,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';

import { ItemSelectorGroup } from '@unified-checkout/design-system';

import type { IField } from '@app/dashboard/types/outerLayout/common';
import {
  ALL_CUSTOMER_INFO_FIELDS,
  CUSTOMER_INFO_FIELD_MAP,
  MANDATORY_CUSTOMER_INFO,
  MANDATORY_CUSTOMER_INFO_KEYS,
} from '@app/dashboard/constants/payment-links/single-payments';

const MandatoryItemsSelector = ({
  setFields,
  customerDetailsType,
}: {
  setFields: Dispatch<SetStateAction<IField>>;
  customerDetailsType: string;
}) => {
  const { t } = useTranslation();

  const [mandatoryCustomerInfoType, setMandatoryCustomerInfoType] =
    useState<string>(MANDATORY_CUSTOMER_INFO_KEYS.PHONE);

  const mandatoryCustomerInfoOptions = useMemo(
    () =>
      MANDATORY_CUSTOMER_INFO(t).map((item) => ({
        ...item,
        checked: item.value === mandatoryCustomerInfoType,
        onClickHandler: () => handleMandatoryCustomerOptionsChange(item.value),
      })),
    [mandatoryCustomerInfoType, t]
  );

  const handleMandatoryCustomerOptionsChange = (value: string) => {
    if (!value) return;

    const fieldsToEnable = CUSTOMER_INFO_FIELD_MAP[value] || [];

    setFields((prev: any) => {
      const updatedFields = { ...prev };

      ALL_CUSTOMER_INFO_FIELDS.forEach((field) => {
        if (fieldsToEnable.includes(field)) {
          updatedFields[field] = {
            value: true,
          };
        } else {
          delete updatedFields[field];
        }
      });

      return updatedFields;
    });

    setMandatoryCustomerInfoType(value);
  };

  useEffect(() => {
    setMandatoryCustomerInfoType(MANDATORY_CUSTOMER_INFO_KEYS.PHONE);
  }, [customerDetailsType]);

  return (
    <ItemSelectorGroup
      label={t(
        'innerLayout.paymentLinksCreationPages.singlePaymentLink.sections.customerDetails.mandatoryCustomerInfo'
      )}
      type="radio"
      items={mandatoryCustomerInfoOptions}
      hasFirstItemSelected
    />
  );
};

export default memo(MandatoryItemsSelector);
